export default __webpack_public_path__ + "static/media/holiday-background-harbolnas.83abd350.png";